class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.addEventListener('submit', this.handleCheckoutSubmit.bind(this));
    this.addEventListener('click', this.handleCheckoutClick.bind(this));

    this.notification.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    this.clearProducts();

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKeys = this.getCartItemKeys(parsedState);
    this.cartItemKey = this.cartItemKeys[0];
    this.clearProducts();

    this.getSectionsToRender().forEach((section) => {
      const item = document.getElementById(section.id);
      const sectionHTML = parsedState.sections && parsedState.sections[section.id];
      if (!item || !sectionHTML) return;

      if (section.id === 'cart-notification-product') {
        this.renderProductSections(item, sectionHTML, section.selector);
      } else {
        item.innerHTML = this.getSectionInnerHTML(
          sectionHTML
        );
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: this.cartItemKey
          ? `[id="cart-notification-product-${this.cartItemKey}"]`
          : '[id^="cart-notification-product-"]',
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getCartItemKeys(parsedState) {
    if (parsedState.key) return [parsedState.key];
    if (Array.isArray(parsedState.items)) {
      return parsedState.items.map((item) => item.key).filter(Boolean);
    }
    return [];
  }

  renderProductSections(item, html, selector) {
    const productElements = this.getProductElements(html, selector);
    let insertAfter = item;

    productElements.forEach((productElement) => {
      const itemCopy = item.cloneNode(false);
      itemCopy.innerHTML = productElement.innerHTML;
      itemCopy.id = productElement.id;
      insertAfter.insertAdjacentElement('afterend', itemCopy);
      insertAfter = itemCopy;
    });
  }

  getProductElements(html, selector) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const selectedElements = [];

    this.cartItemKeys.forEach((key) => {
      const productElement = parsedHTML.getElementById(
        `cart-notification-product-${key}`
      );
      if (productElement) selectedElements.push(productElement);
    });

    if (!selectedElements.length && selector) {
      const productElement = parsedHTML.querySelector(selector);
      if (productElement) selectedElements.push(productElement);
    }

    if (!selectedElements.length) {
      selectedElements.push(
        ...parsedHTML.querySelectorAll('[id^="cart-notification-product-"]')
      );
    }

    return selectedElements;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const section = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);

    return section ? section.innerHTML : '';
  }

  clearProducts() {
    const products = this.notification.querySelectorAll(
      '[id^="cart-notification-product-"]'
    );

    products.forEach((product) => product.remove());
  }

  handleCheckoutSubmit(evt) {
    const checkoutButton = evt.submitter;
    const isCheckoutSubmit =
      evt.target.id === 'cart-notification-form' ||
      (checkoutButton && checkoutButton.getAttribute('name') === 'checkout');

    if (!isCheckoutSubmit) return;

    evt.preventDefault();
    this.goToCheckout();
  }

  handleCheckoutClick(evt) {
    const checkoutButton = evt.target.closest(
      'button[name="checkout"], input[name="checkout"][type="submit"]'
    );
    if (!checkoutButton || !this.contains(checkoutButton)) return;

    evt.preventDefault();
    this.goToCheckout();
  }

  goToCheckout() {
    window.location.href = this.getCheckoutUrl();
  }

  getCheckoutUrl() {
    const checkoutLink = this.querySelector('a[href*="/checkout"]');
    if (checkoutLink) return checkoutLink.href;

    const root = (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) || '/';
    const checkoutPath = `${root.replace(/\/?$/, '/')}checkout`;

    return new URL(checkoutPath, window.location.origin).toString();
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure
        ? disclosure.querySelector('summary')
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('cart-notification', CartNotification);
